import { METHOD } from '../method'

export const API_FLASH_SALE = {
    DETAIL: {
        api: '/v1/dashboard-admin/main-page/home-page/flash-sale',
        method: METHOD.GET,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/main-page/home-page/flash-sale',
        method: METHOD.PUT,
    },
}
